const blockAttributes = {
	title: {
		type: "string",
		default: "Payment Form",
	},
	alignment: {
		type: "string",
		default: "center",
	},
	bg_color: {
		type: "string",
		default: "#000000",
	},
	text_color: {
		type: "string",
		default: "#000000",
	},
};

export default blockAttributes;
